export const facilityQueryKeys = {
  all: () => "facility"
};
